// Enum strings come from the Core contract and the production dashboard;
// unknown values are shown raw on purpose (label ?? value) so drift is visible.

export const WORKFLOW_STATES = Object.freeze([
    'proposed', 'ready', 'claimed', 'in_review', 'returned', 'blocked', 'done', 'discarded',
]);

export const WORKFLOW_STATE_LABEL = Object.freeze({
    proposed: 'Propuesta',
    ready: 'Lista para tomar',
    claimed: 'En progreso',
    in_review: 'En revisión',
    returned: 'Devuelta',
    blocked: 'Bloqueada',
    done: 'Hecha',
    discarded: 'Descartada',
});

export const WORKFLOW_STATE_TONE = Object.freeze({
    proposed: 'idle',
    ready: 'accent',
    claimed: 'running',
    in_review: 'waiting',
    returned: 'blocked',
    blocked: 'blocked',
    done: 'ok',
    discarded: 'idle',
});

export const TASK_KIND_LABEL = Object.freeze({ feature: 'Funcionalidad', fix: 'Corrección', test: 'Pruebas' });

export const ESTIMATE_LABEL = Object.freeze({ S: 'Pequeña', M: 'Mediana', L: 'Grande' });

export const PROJECT_STATE_LABEL = Object.freeze({ active: 'Activo', paused: 'Pausado', closed: 'Cerrado' });
export const PROJECT_STATE_TONE = Object.freeze({ active: 'ok', paused: 'waiting', closed: 'idle' });

export const PHASE_LABEL = Object.freeze({
    discovery: 'Descubrimiento',
    architecture: 'Arquitectura',
    construction: 'Construcción',
    stabilization: 'Estabilización',
    delivery: 'Entrega',
    operation: 'Operación',
    ready: 'Lista para tiers',
});

export const PHASE_ORDER = Object.freeze([
    'discovery', 'architecture', 'construction', 'stabilization', 'delivery', 'operation',
]);

export const PLAN_STATE_LABEL = Object.freeze({ draft: 'Borrador', in_review: 'En revisión', approved: 'Aprobada' });
export const PLAN_STATE_TONE = Object.freeze({ draft: 'idle', in_review: 'waiting', approved: 'ok' });

export const REPOSITORY_KIND_LABEL = Object.freeze({
    backend: 'Backend',
    frontend: 'Frontend',
    admin: 'Panel',
    mobile: 'Móvil',
    infra: 'Infraestructura',
});

export const TEAM_ROLE_LABEL = Object.freeze({
    lead: 'Lead', dev: 'Dev', qa: 'QA', design: 'Diseño', ops: 'Ops', member: 'Miembro',
});

export const FINDING_RESULT_LABEL = Object.freeze({
    cumple: 'Cumple', incumple: 'Incumple', no_comprobado: 'No comprobado',
});
export const FINDING_RESULT_TONE = Object.freeze({ cumple: 'ok', incumple: 'blocked', no_comprobado: 'waiting' });

export const ROUND_STATE_LABEL = Object.freeze({
    open: 'Esperando decisión', approved: 'Aprobada', returned: 'Devuelta',
});
export const ROUND_STATE_TONE = Object.freeze({ open: 'waiting', approved: 'ok', returned: 'blocked' });

export const DECISION_RESULT = Object.freeze({ APPROVED: 'approved', RETURNED: 'returned' });
export const DECISION_REASON_MAX = 2000;

export const AGENT_ROLE_LABEL = Object.freeze({ agent_master: 'Maestro', agent_slave: 'Esclavo' });
export const PROVIDER_LABEL = Object.freeze({
    claude_code: 'Claude Code', codex: 'Codex', cursor: 'Cursor', other: 'Otro',
});

export const AGENT_STATUS = Object.freeze({
    RUNNING: 'running',
    CONNECTED: 'connected',
    WAITING: 'waiting',
    BLOCKED: 'blocked',
    OFFLINE: 'offline',
});

export const AGENT_STATUS_LABEL = Object.freeze({
    running: 'Ejecutando',
    connected: 'Conectado',
    waiting: 'En espera',
    blocked: 'Bloqueado',
    offline: 'Sin conexión',
});

export const AGENT_STATUS_TONE = Object.freeze({
    running: 'running', connected: 'ok', waiting: 'waiting', blocked: 'blocked', offline: 'idle',
});

export const STALE_REASON_LABEL = Object.freeze({
    sin_latidos: 'Sin latidos',
    sin_conexion: 'Sin conexión',
    vigencia_vencida: 'Reserva vencida',
    orden_vencida: 'Orden vencida',
    vinculo: 'Vínculo roto',
    orden_sin_entregar: 'Orden sin entregar',
});

export const ATTENTION_KIND_LABEL = Object.freeze({
    permisos_del_proveedor: 'Permisos del proveedor',
    limite_de_uso: 'Límite de uso',
    revision_incompleta: 'Revisión incompleta',
    reserva_perdida: 'Reserva perdida',
    error_recuperable: 'Error recuperable',
    equipo_ausente: 'Equipo ausente',
});

export const EVENT_KIND_LABEL = Object.freeze({
    'task.claimed': 'Tarea tomada',
    'task.progress': 'Avance',
    'task.delivered': 'Entrega',
    'task.proposed': 'Hallazgo',
    'task.blocked': 'Bloqueo',
    'task.lease_expired': 'Reserva vencida',
    'review.decided': 'Decisión de revisión',
    'plan.version': 'Plan',
    'agent.stale': 'Agente sin señal',
    'agent.order': 'Orden a agente',
});

export const EVENT_KIND_TONE = Object.freeze({
    'task.claimed': 'running',
    'task.progress': 'running',
    'task.delivered': 'waiting',
    'task.proposed': 'accent',
    'task.blocked': 'blocked',
    'task.lease_expired': 'blocked',
    'review.decided': 'ok',
    'plan.version': 'accent',
    'agent.stale': 'blocked',
    'agent.order': 'idle',
});
